import { ConstructionCode, ContinuityType, MaterialType, WPSCode } from "./menus";
import { ScopeOfWork, ScopeOfWorkStatus } from "@/api/williams/scopesOfWork";

const messages = {
  GA1: "You did not select a contractor. The system is unable to determine if welder qualifications are applicable for the contractor.",
  GA2: "This is a New York project. Additional requirements may apply. Contact an AI Welding SME.",
  GA3: "Compressor Stations often require qualification by destructive testing only. You selected to allow qualifications by NDE.",
  GA4: "You did not select the Incorporated by Reference Edition (IBR). Current IBR editions are API 1104 21st edition and ASME Section IX-2007",
  GA5: "API 1104 welder qualifications are not allowed for ASME B31.3; ASME Section IX qualifications must be used.",
  GA6: "Reach out to the AI Welding SME Group or Welding/NDT Specialist. You selected Unknown, non-code, or not-listed for the Construction Code.",
  GA7: "Contact AI Welding SMEs for assistance with materials that are not listed.",
  GA8: "Basic or Basic+NDE continuity requires AI Welding SME approval.",
  GA9: "Contact AI Welding SMEs or Welding/NDT Specialist for help with Unknown or Not Listed WPS Code.",
  GA10: "You selected a scope of work that is not governed by CFR. Most work at Williams is CFR governed. Verify that CFR does not apply.",
  GA11: "You selected a scope of work with CFR 193 for LNG facilities. CFR 193 can have unique requirements, please contact AI Welding SMEs for support.",
  GA12: "ASME B31.4/Non-CFR does not allow ASME Section IX for cross-country pipelines. Switch WPS code to API 1104 if scope of work is cross-country pipeline.",
};

export function getAdvisories(data: ScopeOfWork): string[] {
  const advisories: string[] = [];

  if (data.locked) {
    // Don't show advisories when the form is locked.
    return advisories;
  }
  if (!data.contractorId && data.status > ScopeOfWorkStatus.Partial) {
    advisories.push(messages.GA1);
  }
  if (data.newYorkProject) {
    advisories.push(messages.GA2);
  }
  if (data.allowQualificationsByNde) {
    advisories.push(messages.GA3);
  }
  if (
    data.constructionCode === ConstructionCode.Unknown ||
    data.constructionCode === ConstructionCode.NonCode ||
    data.constructionCode === ConstructionCode.NotListed
  ) {
    advisories.push(messages.GA6);
  }
  if (data.materials === MaterialType.NotListed) {
    advisories.push(messages.GA7);
  }
  if (data.continuityType === ContinuityType.Basic || data.continuityType === ContinuityType.BasicNDE) {
    advisories.push(messages.GA8);
  }
  if (data.wpsCode === WPSCode.Unknown || data.wpsCode === WPSCode.NotListed) {
    advisories.push(messages.GA9);
  }
  if (data.constructionCode?.includes("Non-CFR")) {
    advisories.push(messages.GA10);
  }
  if (data.constructionCode?.includes("193")) {
    advisories.push(messages.GA11);
  }
  if (data.constructionCode === ConstructionCode.ASMEB31_4_NonCFR && data.wpsCode === WPSCode.ASMESectionIX) {
    advisories.push(messages.GA12);
  }

  return advisories;
}
